<template>
  <div class="dash">
    <Dash />
  </div>
</template>

<script>
// @ is an alias to /src
import Dash from "@/components/Dash.vue";

export default {
  name: "DashRoute",
  components: {
    Dash
  }
};
</script>
